/** Libellé court du type d'objet, en tête de l'onglet du galet (EP-1120) */
const OBJECT_TYPE_LABELS: Record<string, string> = {
  OFFER: "Offre",
  PROJECT: "Chantier",
  CUSTOMER: "Client",
  INVOICE: "Facture",
  INTERVENTION: "Intervention",
  SUPPLIER: "Fournisseur",
  EMPLOYEE: "Collaborateur",
  PURCHASE_ORDER: "Bon de commande",
};

const CIVILITY = /^(monsieur|madame|mademoiselle|m\.|mme|mlle)\s+/i;

/**
 * Même gabarit « Type + identifiant court » pour tous les modules :
 * « Offre 20261014-3 », « Chantier WT-P-22-1022 », « Client Jacques BLANC ».
 */
export function formatObjectScopeLabel(
  objectType: string | null | undefined,
  objectName: string | null | undefined,
): string {
  const typeLabel = OBJECT_TYPE_LABELS[(objectType || "").toUpperCase()] || "";
  let name = (objectName || "").trim();
  if (typeLabel && name.toLowerCase().startsWith(typeLabel.toLowerCase())) {
    // « Offre n°20261014-3 » ou libellé de repli « Chantier » : on retire le type déjà présent
    name = name
      .slice(typeLabel.length)
      .replace(/^\s*(n°|no\.?)?\s*/i, "")
      .trim();
  }
  name = name.replace(CIVILITY, "");
  if (!typeLabel) return name || "Cet élément";
  return name ? `${typeLabel} ${name}` : typeLabel;
}
